import * as CommonUtil from '/app/js/util/Common.js'
import * as Config from "/app/js/common/Config.js";
import * as UIUtil from "/app/js/util/UI.js";
import * as Menu from "/app/js/common/Menu.js";
import * as Header from "/app/js/panel/Header.js";


const contextPath = `${Config.HOST.APP_CONTEXT_PATH}`;

const fileList = [

    `${contextPath}/app/lib/jquery/jquery-1.12.4.min.js`,
    `${contextPath}/app/lib/jquery/jquery.easing.1.3.js`,

    `${contextPath}/app/lib/slick/slick.min.js`,

    `${contextPath}/app/lib/scrollmagic/ScrollMagic.min.js`,

    `${contextPath}/app/js/util/ui.common.js`,

    `${contextPath}/app/lib/o2/o2-1.0.0.js`,
    // `${contextPath}/app/lib/o2/o2-1.0.0.css`,

    `${contextPath}/app/css/sub.css`,

]

CommonUtil.loadLib(fileList).then(async () => {
    initConfig();
    await initialize();
});

async function initialize() {

    initEvt();

    const lastLang = localStorage.getItem('lang') || 'KOR';
    await UIUtil.changeLang(lastLang, false);

    // URL 해시 파싱 (#News/123 → menuKey: 'News', id: '123')
    let menuKey = 'Main';
    let detailId = null;
    let detailType = null;

    if (location.hash) {
        const hashValue = location.hash.substring(1); // #News/123 → News/123
        const parts = hashValue.split('/');

        menuKey = parts[0]; // 'News'

        // 상세 페이지 ID가 있는 경우
        if (parts.length > 1 && parts[1]) {
            detailId = parts[1];
            if (menuKey === 'News') {
                detailType = 'news';
            } else if (menuKey === 'Notice') {
                detailType = 'notice';
            }
        }
    }

    // 상세 페이지로 직접 접근한 경우
    if (detailId && detailType) {
        // 페이지 초기화 (서브 페이지로 설정)
        await UIUtil.clearPage(false);

        // Header 초기화
        await Header.init();

        // 메뉴 활성화 상태 설정
        const beforeMenuKey = Menu.getActiveMenuKey();
        const targetMenuKey = detailType === 'news' ? 'News' : 'Notice';
        Menu.setActiveMenu(targetMenuKey, beforeMenuKey);

        // GNB 메뉴 활성화 상태 업데이트
        Header.updateGnbActiveState();

        // 히스토리 상태 설정 (pushState 대신 replaceState 사용)
        if (detailType === 'news') {
            history.replaceState({ menuKey: 'News', newsId: detailId }, '', `#News/${detailId}`);
            const NewsDetail = await import('./news/panel/NewsDetail.js');
            await NewsDetail.open(detailId, false);
        } else if (detailType === 'notice') {
            history.replaceState({ menuKey: 'Notice', noticeId: detailId }, '', `#Notice/${detailId}`);
            const NoticeDetail = await import('./notice/panel/NoticeDetail.js');
            await NoticeDetail.open(detailId, false);
        }

        // Footer 및 Gallery 초기화 (Menu.openMenu()과 동일하게)
        const Gallery = await import('./panel/Gallery.js');
        await Gallery.init();

        const Footer = await import('./panel/Footer.js');
        await Footer.init();
    } else {
        // 일반 메뉴로 접근
        await Menu.openMenu(menuKey);
    }

}

function initConfig() {
    o2.common.Config.HOST.APP_CONTEXT_PATH = `${contextPath}`;
    o2.common.Config.HOST.APP_PROXY = 'common/proxy.jsp';

}

function initEvt() {

    initDaumMapLib();

}

window.addEventListener('popstate', async (event) => {

    const state = event.state || {};
    const menuKey = state.menuKey || 'Main';
    const newsId = state.newsId;
    const noticeId = state.noticeId;

    // NewsDetail에서 뒤로가기한 경우
    if (menuKey === 'News' && newsId) {
        const NewsDetail = await import('./news/panel/NewsDetail.js');
        await NewsDetail.open(newsId, false);
    } else if (menuKey === 'News' && !newsId) {
        await Menu.openMenu(menuKey);
    }
    // NoticeDetail에서 뒤로가기한 경우
    else if (menuKey === 'Notice' && noticeId) {
        const NoticeDetail = await import('./notice/panel/NoticeDetail.js');
        await NoticeDetail.open(noticeId, false);
    } else if (menuKey === 'Notice' && !noticeId) {
        await Menu.openMenu(menuKey);
    }
    // 일반 메뉴 이동
    else {
        Menu.openMenu(menuKey);
    }
});

function initDaumMapLib() {
    (function () {
        var c = "https:"; // 명시적으로 HTTPS 사용
        var a = "7a65d0c7";
        var p = "prod";

        if (window.daum && window.daum.roughmap && window.daum.roughmap.cdn) {
            return;
        }

        window.daum = window.daum || {};
        window.daum.roughmap = {
            phase: p,
            cdn: a,
            URL_KEY_DATA_LOAD_PRE: c + "//t1.daumcdn.net/roughmap/",
            url_protocal: c,
            url_cdn_domain: "//t1.daumcdn.net",
        };

        var b = c + "//t1.daumcdn.net/kakaomapweb/roughmap/place/" + p + "/" + a + "/roughmapLander.js";

        var script = document.createElement("script");
        script.charset = "UTF-8";
        script.src = b;
        document.head.appendChild(script); // head에 추가하는것이 권장됩니다.
    })();
}